import _ from 'lodash';
import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import MdDateRange from 'react-icons/lib/md/date-range'
import MdCloudDownload from 'react-icons/lib/md/cloud-download'
import DatePicker from 'material-ui/DatePicker';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';

import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { getJobById } from '../../Reducers';
import * as actions from '../../Actions/index';
import EditManual from './AudioVisual';
import Moment from 'react-moment';
import Dialog from 'material-ui/Dialog';
import LinearProgress from 'material-ui/LinearProgress';
import moment from 'moment';
import FaShareSquare from 'react-icons/lib/fa/share-square'
import '../../assets/css/process.css'
import { DialogContent } from '@material-ui/core';

class JobDetails extends React.Component {
	constructor(props) {
		super(props);
		this.filterToggle = this.filterToggle.bind(this);
		this.state = {
			open: false,
			filter: 'active-dashboard',
			editManual: null,
			showRefreshLayer: false,
			showJobCompletionDateLayer: false,
			showCustomerLayer: false,
			showDeleteLayer: false,
			showSiteLayer: false,
			modalIsOpen: false,
			authorizeModal: true,
			modalIsOpenManual: false,
			modalIsOpenReimport: false,
			modalIsOpenReimportProgressBar: false,
			OpensendToSimproModal: false,
			authorizeLoader: true,
			jobAuthor: null,
			// dateIsReqText: '',
			// siteName = this.props.job.simpro_job.Site.SiteName,
			createJobManualError: {},
			selectedTemplateSet: '',
			simpro_name_req: '',
			simpro_pass_req: '',
			simproUsername: '',
			simproPassword: '',
			statusJobManualError: '',
			importStatus: false,
			mergeStatus: false,
			optimizeStatus: false,
			exportStatus: false,
			pdfStoreStatus: false,
			pdfConvertStatus: false,
			interval: false

		}
		this.selectTile = this.selectTile.bind(this);
		this.closeLayer = this.closeLayer.bind(this);
		this.updateJob = this.updateJob.bind(this);
		this.deleteJob = this.deleteJob.bind(this);
		this.setDate = this.setDate.bind(this);
		this.createManual = this.createManual.bind(this);
		//this.editJobCompletionDate = this.editJobCompletionDate.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openModalManual = this.openModalManual.bind(this);
		this.closeModalManual = this.closeModalManual.bind(this);
		this.openModalReimport = this.openModalReimport.bind(this);
		this.closeModalReimport = this.closeModalReimport.bind(this);
		this.reimport = this.reimport.bind(this);
		this.closeModalPopup = this.closeModalPopup.bind(this);
		this.sendToSimpro = this.sendToSimpro.bind(this);
		this.closeAuthorizePopup = this.closeAuthorizePopup.bind(this);
		this.authorize = this.authorize.bind(this);
	}

	handleChange2 = (event, index, value) => {
		this.setState({ value: value });
	}
	closeModalPopup() {
		this.setState({ modalIsOpenReimport: false });
		this.props.resetJobReimportPopup();
		window.location.href = "/job";

	}
	openModalReimport() {
		this.setState({ modalIsOpenReimport: true });
	}
	closeModalReimport() {
		this.setState({ modalIsOpenReimport: false });
	}
	openModal() {

		this.setState({ modalIsOpen: true });
	}
	closeModal() {
		this.setState({ modalIsOpen: false });
	}
	manualCreationInterval() {
		 var interval =  setInterval(() => {
				this.setState({ time: Date.now() })
				if (this.state.modalIsOpenManual && this.props.isCreatingDocument) {
					this.getManualStatus()
					console.log("manualCreationStatus===>", this.props.manualStatus)
				}else{
					console.log("clarinterval called===>")
					clearInterval(this.state.interval)
				}
			}, 1000)
			this.setState({interval : interval})
	}

	openModalManual() {
		this.setState({ modalIsOpenManual: true });
		this.manualCreationInterval();
	}
	closeModalManual() {
		this.setState({ modalIsOpenManual: false });
		this.props.statusJobReset(this.props.job.simpro_id)
		.then((err) => {
			if (err) {
				this.setState({
					statusJobManualError: err.err
				})
			}
		});
		this.setState({
			importStatus: false,
			mergeStatus: false,
			optimizeStatus: false,
			exportStatus: false,
			pdfStoreStatus: false,
			pdfConvertStatus: false
		})
	}
	deleteJob() {
		let companyId = this.props.currentuser.company._id;
		this.setState({ modalIsOpen: false });
		this.props.deleteJob(this.props.job.simpro_id).then(() => {
			window.setTimeout(() => {
				this.props.fetchJobs(companyId);
				this.props.fetchLoginUserDetail();
				this.props.history.push('/job');
			}, 2000);
		});
	}
	setDate(e, date) {
		let job = this.props.job;
		job.job_completion_date = moment(date).format('MMM-DD-YYYY');

		this.setState({
			createJobManualError: { ...this.state.createJobManualError, job_completion_date: "" },
		})

		// this.setState({ dateIsReqText: '' });
		this.updateJobCompletionDate(job);
	}

	setAuthor = (e) => {
		let job = this.props.job;
		job.jobAuthor = e.target.value || "";
		this.setState({ jobAuthor: e.target.value || "" })
		this.updateJobCompletionDate(job);
	}

	changeJobAuthorText = (e) => {
		this.setState({ jobAuthor: e.target.value || "" })
	}

	setCustomerCompanyName = (e) => {
		let job = this.props.job;
		job.simpro_job.Customer.CompanyName = e.target.value || this.props.job.simpro_job.Customer.CompanyName;
		this.setState({ customerCompanyName: e.target.value || this.props.job.simpro_job.Customer.CompanyName })
		this.updateJobCompletionDate(job);
	}
	changeJobCustomerCompanyNameText = (e) => {
		this.setState({ customerCompanyName: e.target.value || this.props.job.simpro_job.Customer.CompanyName })
	}

	setSiteName = (e) => {
		let job = this.props.job;
		job.simpro_job.Site.SiteName = e.target.value || this.props.job.simpro_job.Site.SiteName;
		this.setState({ siteName: e.target.value || this.props.job.simpro_job.Site.SiteName })
		this.updateJobCompletionDate(job);
	}
	changeJobSiteNameText = (e) => {
		this.setState({ siteName: e.target.value || this.props.job.simpro_job.Site.SiteName })
	}


	selectTile(manualType) {
		const jobid = this.props.job.simpro_id;
		this.setState({
			editManual: manualType,
			showRefreshLayer: false
		});
		this.props.history.push(`/job/${jobid}/editmanual`);
	}
	closeLayer() {
		this.setState({
			editManual: null,
			showRefreshLayer: false,
			showJobCompletionDateLayer: false,
			showCustomerLayer: false,
			showDeleteLayer: false,
			showSiteLayer: false
		});
		const jobid = this.props.job.simpro_id;
		this.props.history.push(`/job/${jobid}`);
	}
	updateJobCompletionDate(job) {
		this.props.updateJob(job);
	}
	updateJob(job) {
		this.props.updateJob(job);
		this.closeLayer();
	}
	updatePartNameOFJob = (job) => {
		this.props.updateJob(job);
		// this.closeLayer();
	}
	reimport() {
		let jobId = this.props.job.simpro_id;
		let compId = this.props.currentuser.companydetail.company_id;
		let simproCompId = this.props.job.simpro_company_id;
		
		this.props.reimportJob(jobId, compId, simproCompId);
		
		sessionStorage.setItem(jobId, jobId);

	}
	createManual() {

		let error = {}
		if (!this.props.job.job_completion_date) {
			error.job_completion_date = 'Please select project completion date.'
		}

		// if (!this.props.job.jobAuthor) {
		// 	error.jobAuthor = 'Please enter O&M Author name.'
		// }

		if (!this.props.job.template_set_id) {
			error.templateset = 'Please choose a template set first to create job manual.'
		}

		if (!_.isEmpty(error)) {
			this.setState({
				createJobManualError: { ...this.state.createJobManualError, ...error },
			})
		} else {
			this.openModalManual();
			let compId = this.props.currentuser.companydetail.company_id;
			if (this.props.isCreatingDocument == false) {
				this.props.createJobDocument(this.props.job.simpro_id, compId)
					.then((err) => {
						if (err) {
							this.setState({
								createJobManualError: err.err
							})
						}
					});
				this.props.statusJobReset(this.props.job.simpro_id)
				this.setState({
					importStatus: false,
					mergeStatus: false,
					optimizeStatus: false,
					exportStatus: false,
					pdfStoreStatus: false,
					pdfConvertStatus: false
				})
			}
		}
	}

	getManualStatus = () => {
		this.props.statusJob(this.props.job.simpro_id, this.props.currentuser.companydetail.company_id)
			.then((err) => {
				if (err) {
					this.setState({
						statusJobManualError: err.err
					})
				}
			});

		if (this.props.manualStatus.includes("import/url")) {
			this.setState({ importStatus: true })
			if (this.props.manualStatus.includes("merge")) {
				this.setState({ mergeStatus: true })
				if (this.props.manualStatus.includes("optimize")) {
					this.setState({ optimizeStatus: true })
					if (this.props.manualStatus.includes("pdf/store")) {
						this.setState({ pdfStoreStatus: true })
						if (this.props.manualStatus.includes("export/s3")) {
							this.setState({ exportStatus: true })
							if (this.props.manualStatus.includes("pdf/convert")) {
								this.setState({
									pdfConvertStatus: true,
								})
							}
						}
					}
				}
			}
		}
	}

	componentDidMount = () => {
		const query = new URLSearchParams(this.props.location.search);
		let urlParm = query.get('allowJobImp');
		sessionStorage.removeItem(urlParm);
		if(urlParm){
			// console.log("url==>3", window.location.origin + window.location.pathname);
			setTimeout(() => {
				window.location.href = window.location.origin + window.location.pathname;
			}, 1000);
		}
	}
	// componentDidMount = () => {
	// 	if (this.state.modalIsOpenManual && this.props.isCreatingDocument) {
	// 		console.log("runned interval")
	// 		this.manualCreationInterval();
	// 	}else{
	// 		console.log("clearInterval called");
	// 		clearInterval(this.manualCreationInterval)
	// 	}
	// }
	componentWillUnmount() {
		let compId = this.props.currentuser && this.props.currentuser.companydetail && this.props.currentuser.companydetail.company_id ? this.props.currentuser.companydetail.company_id : '';
		if (compId) {
			// to update templates propes that is updated from dropdown
			this.props.fetchManuals(compId);
		}
	}
	componentWillReceiveProps(newprops) {
		window.setTimeout(() => {
			if (this.props.jobs.tokenStatus === 1) {
				this.setState({ modalIsOpenReimport: false, modalIsOpenManual: false, authorizeModal: true })
			}
		}, 100)
		if (this.props.job) {
			this.setState({ jobAuthor: this.props.job.jobAuthor });
		}
	}
	sendToSimpro() {
		this.openModalManual();
		let compId = this.props.currentuser.companydetail.company_id;
		let jobId = this.props.job.simpro_id;
		let createdManualUrl = this.props.job.pdf_download_url
		let simpro_company_id = this.props.job.simpro_company_id;
		this.props.sendToSimpro(compId, jobId, simpro_company_id, createdManualUrl);
	}
	handleOpen = () => {
		this.setState({ open: true });
	};
	handleClose = () => {
		this.setState({ open: false });
	};
	filterToggle() {
		let value = (this.state.filter === 'active-dashboard') ? 'deactivate-dashboard' : 'active-dashboard'
		this.setState({ filter: value });
	}

	closeAuthorizePopup() {
		this.setState({ authorizeModal: false });
	}
	templatesList(templatesList, manualType) {
		let checkTosetTemp = false;
		let templistIsUsed = _.filter(templatesList, function (temp, i) {
			return temp.is_used === true;
		});
		if (templistIsUsed.length !== 0) {
			let val = templistIsUsed[0]._id;
			let check = this.state[manualType];
			if (!check) {
				this.setState({ [manualType]: val });
				checkTosetTemp = true;
			}
		}
		if (checkTosetTemp === false) {
			let templist = _.filter(templatesList, function (temp, i) {
				return temp.subtype !== true;
			});
			if (templist.length !== 0) {
				//let val = templist[0].category + '-' + templist[0].title;
				let val = templist[0]._id;
				let check = this.state[manualType];
				if (!check) {
					this.setState({ [manualType]: val })
				}
			}
		}

		//this.setState({[manualType]:})
		//value={`${item.category}-${item.title}`}
		return _.map(templatesList, (item) => {
			return (
				<MenuItem key={item._id} value={item._id} primaryText={item.title} />
			);
		});




	}

	_getTemplateSet = () => {
		return _.map(this.props.companyTemplateSet, (item) => {
			return (
				<MenuItem key={item._id} value={item._id} primaryText={item.template_set_name} />
			);
		});
	}
	_selectTemplateSet = (event, index, value) => {

		if (this.props.job.template_set_id !== value) {
			this.setState({
				selectedTemplateSet: value,
				createJobManualError: { ...this.state.createJobManualError, templateset: "" },
			}, () => {
				let job = this.props.job;
				job.template_set_id = this.state.selectedTemplateSet;
				this.updateJobCompletionDate(job);
			})
		}


	}


	authorize() {
		const { currentuser, jobs } = this.props;
		let check = true;
		let companyId = currentuser.companyData ? currentuser.companyData.companyId : jobs.companyData.companyId;
		let url = currentuser.companyData ? currentuser.companyData.simpro_url : jobs.companyData.simpro_url;
		let simprouser = currentuser.companyData ? currentuser.companyData.simpro_user : jobs.companyData.simpro_user;
		let simpropass = currentuser.companyData ? currentuser.companyData.simpro_pas : jobs.companyData.simpro_pas;
		this.props.authorizeApi(companyId, url, simprouser, simpropass, check);
	}
	closeModalPopupForError = () => {
		this.props.closeModalPopupForError();
	}
	findAllEncryptedFiles = (type) => {
		let files = this.props.mergeFilesListing;
		let cloudConverRes = this.props.cloudConvertRes;
		this.props.findAllEncryptedFiles(files, cloudConverRes, type);
	};
	renderErrorFiles = () => {
		return this.props.moreEncryptedFiles.map(function (file, index) {
			return (
				<span> {index + 1}. {file}</span>
			);
		})
	}
	authorizeApi = (e) => {
		let simprouser = this.state.simproUsername;
		let simpropass = this.state.simproPassword;
		if (simprouser.includes('@')) {
			this.setState({ simpro_name_req: "Pleae enter your Simpro username.", buttonDisable: false });
			return false;
		}
		if (simprouser === '') {
			this.setState({ simpro_name_req: "Please enter your simpro's user name.", buttonDisable: false });
			return false;
		} else {
			this.setState({ simpro_name_req: '' });
		}
		if (simpropass === '') {
			this.setState({ simpro_pass_req: "Please enter your simpro's Password.", buttonDisable: false });
			return false;
		} else {
			this.setState({ simpro_pass_req: '' });
		}
		let compId = this.props.currentuser && this.props.currentuser.company && this.props.currentuser.company._id;
		this.props.updateSimproDetails(simprouser, simpropass, compId, () => {
			window.location = '/job'
			// this.props.history.push(`/job`)
		});
	}
	simPROpassword = (e) => {
		let simpropass = e.target.value;
		this.setState({ simproPassword: simpropass });
	}
	simPROUser = (e) => {
		let simprouser = e.target.value;
		this.setState({ simproUsername: simprouser });
	}
	cancelSimproUpdate = () => {
		this.props.cancelSimproUpdate()
	}
	handleFocus = (e) =>{
		if (e.target.hasAttribute('readonly')) {
		  e.target.removeAttribute('readonly');
		  e.target.blur();
		  e.target.focus();  
		}
	}

	render() {
		// console.log("here is all the simproStatus",this.props.simproAuthenticationFailed)

		let compId = this.props.currentuser && this.props.currentuser.company && this.props.currentuser.company._id;
		if (!this.props.job) {
			return null; // TODO: Return a loading indicator
		}
		let pdfTime;
		if (this.props.job.pdf_created_at) {
			pdfTime = this.props.job.pdf_created_at;
		}

		const manualSortOrder = ['AUDIO_VISUAL', 'OTHER_WORKS', 'ELECTRICAL', 'FIRE_DETECTION',
			'FLOORING', 'HVAC', 'MECHANICAL', 'RENEWABLES', 'ROOFING', 'SECURITY', 'VOICE_DATA'];
		let checkmanual = this.props.job.manuals;
		const sortedManuals = _.sortBy(_.keys(this.props.job.manuals), (m) => {
			return _.indexOf(manualSortOrder, m);
		});

		const manuals = _.map(sortedManuals, (manualType) => {
			let groupsTemplates = _.filter(this.props.templates && this.props.templates.items, function (temp) {
				return temp.category === manualType && temp.type === 'MAIN'
			});
			let templates = this.templatesList(groupsTemplates, manualType);
			let manualTypeText = '';
			let iconClass = '';
			switch (manualType) {
				case 'ELECTRICAL':
					manualTypeText = 'Electrical';
					iconClass = 'zmdi zmdi-input-power';
					break;
				case 'VOICE_DATA':
					manualTypeText = 'Voice Data';
					iconClass = 'zmdi zmdi-phone-in-talk';
					break;
				case 'AUDIO_VISUAL':
					manualTypeText = 'Audio Visual';
					iconClass = 'zmdi zmdi-volume-up';
					break;
				case 'OTHER_WORKS':
					manualTypeText = 'Other Works';
					iconClass = 'zmdi zmdi-case';
					break;
				case 'FIRE_DETECTION':
					manualTypeText = 'Fire Detection';
					iconClass = 'zmdi zmdi-fire';
					break;
				case 'SECURITY':
					manualTypeText = 'Security';
					iconClass = 'zmdi zmdi-shield-security';
					break;
				case 'MECHANICAL':
					manualTypeText = 'Mechanical';
					iconClass = 'zmdi zmdi-wrench';
					break;
				case 'FLOORING':
					manualTypeText = 'Flooring';
					iconClass = 'zmdi zmdi-grid';
					break;
				case 'ROOFING':
					manualTypeText = 'Roofing';
					iconClass = 'zmdi zmdi-balance';
					break;
				case 'HVAC':
					manualTypeText = 'HVAC'
					iconClass = 'zmdi zmdi-toys';
					break;
				case 'RENEWABLES':
					manualTypeText = 'Renewables'
					iconClass = 'zmdi zmdi-refresh';
					break;
				default:
					break;
			}
			const isViewed = this.props.job.manuals[manualType].isViewed;
			return (
				<tr key={`manual-${manualType}`} style={{ height: "50px" }}>
					<td width="70%" onClick={(e) => { this.selectTile(manualType) }}><i className={iconClass}></i>{manualTypeText}</td>
					<td width="30%" className="checkbox-span">
						<input type="checkbox" value="" checked={isViewed ? true : false} className="checkboxs" disabled="true" />
						<span></span>
					</td>
					{/*<td width="30%">
						<SelectField
							onChange={(event, index, value) => {
								this.setState({ [manualType]: value });
								this.props.setMainTemplateToUse(compId, manualType, value);
							}}
							name="selectTemplate"
							value={this.state[manualType]}
							floatingLabelFixed={true}
							hintText="Template"
							className="selectInput"
							fullWidth={true}
						>
							{templates}
						</SelectField>
					</td>*/}
				</tr>
			);
		});
		var completionDate = new Date(this.props.job.job_completion_date);

		const action = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeModal}
			/>,
			<RaisedButton
				label="Yes"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={this.deleteJob}
			/>
		];
		const actionReimport = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeModalReimport}
			/>,
			<RaisedButton
				label="Continue"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={this.reimport}
			/>
		];
		const action1 = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeAuthorizePopup}
			/>,
			<RaisedButton
				label="Re-authorize"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				type='button'
				onClick={this.authorize}
				disabled={this.props.signup.disableaAuthorizeButton === true ? true : false}
			/>
		];

		const { currentuser, jobs, signup } = this.props;

		const selected_template_set_id = this.state.selectedTemplateSet && this.state.selectedTemplateSet.length > 0 ? this.state.selectedTemplateSet : this.props.job.template_set_id
		const { createJobManualError } = this.state
		var author = this.state.jobAuthor;
		var siteName = this.state.siteName ? this.state.siteName : this.props.job.simpro_job.Site.SiteName;
		var customerCompanyName = this.state.customerCompanyName ? this.state.customerCompanyName : this.props.job.simpro_job.Customer.CompanyName;
		return (<div>

			<Route path={`${this.props.match.url}/editmanual`} component={() => <EditManual manual={this.state.editManual} job={this.props.job} onCancel={this.closeLayer} onSave={this.updateJob} updatePartNameOFJob={this.updatePartNameOFJob} />} />
			<Route exact path={this.props.match.url} render={() => (
				<div className="dashboard-page">
					<div className={`right-content-dashboard ${this.state.filter}`}>
						<div className="dashboard-content-sec table-dashboard audio-visual-content">
							<div className="top-heading">
								<div className="back-button-heading">
									<h2><Link to="/job"><MdArrowBack /></Link>JOB #{this.props.job.simpro_id}</h2>
								</div>
								<div className="right-job-id" download>
									{this.props.job.pdf_download_url ?
										<RaisedButton
											label="Download Job Manual"
											type="submit"
											className="download-job"
											icon={<MdCloudDownload fontSize="18px" />}
											labelColor="#fff"
											labelStyle={{ 'fontWeight': '500' }}
											fullWidth={false}
											href={this.props.job.pdf_download_url}
											target='_blank'
										/>
										: null}
									{this.props.job.pdf_download_url ?
										<RaisedButton
											label="SEND TO simPRO"
											icon={<FaShareSquare fontSize="18px" />}
											labelColor="#fff"
											className="download-job"
											labelStyle={{ 'fontWeight': '500', 'text-transform': 'capitalize' }}
											fullWidth={false}
											onClick={this.sendToSimpro}
											disabled={this.props.ismanualSendingToSimpro === true ? true : false}
										/>
										: null}
								</div>

							</div>
							<div className="dashboard-table-data">
								<div className="audio-visual-list">
									<h3>General</h3>
									<table className="dashboard-table">
										<thead>
											<tr>
												<th width="50%">Status </th>
												<th width="50%">{this.props.job.simpro_job.Status.StatusName}</th>
											</tr>
											<tr>
												<th width="50%">Imported at </th>
												<th width="50%">
													<Moment format=" MMM-DD-YYYY , hh:mm a">
														{this.props.job.imported_at}
													</Moment>
												</th>
											</tr>
											<tr>
												<th width="50%">Job Manual PDF created at </th>
												<th width="50%">
													{pdfTime ?
														<Moment format=" MMM-DD-YYYY , hh:mm a">
															{pdfTime}
														</Moment>
														: 'Not Created'
													}

												</th>
											</tr>
											<tr>
												<th width="50%">Sent to simPRO </th>
												<th width="50%">
													{this.props.job.sent_to_simpro ?
														<Moment format=" MMM-DD-YYYY , hh:mm a">
															{this.props.job.sent_to_simpro}
														</Moment>
														: 'Not Uploaded'
													}

												</th>
											</tr>

											<tr>
												<th width="50%">Customer </th>
												<th width="50%">
													<div>
														<input type="text" name="jobCustomerCompany Name" placeholder="Company Name" value={customerCompanyName} onChange={this.changeJobCustomerCompanyNameText} onBlur={this.setCustomerCompanyName} style={{
															'borderTop': 0,
															'borderLeft': 0,
															'borderRight': 0,
															'borderBottom': '1px solid rgba(0, 0, 0, 0.1)',
															'width': '100%',
															'background': 'transparent'
														}} />
													</div>
												</th>
												{/* <th width="50%">{this.props.job.simpro_job.Customer.CompanyName}</th> */}
											</tr>
											<tr>
												<th width="50%">Site </th>
												<th width="50%">
													<div>
														<input type="text" name="jobSiteName" placeholder="Site Name" value={siteName} onChange={this.changeJobSiteNameText} onBlur={this.setSiteName} style={{
															'borderTop': 0,
															'borderLeft': 0,
															'borderRight': 0,
															'borderBottom': '1px solid rgba(0, 0, 0, 0.1)',
															'width': '100%'
														}} />
													</div>
												</th>
												{/* <th width="50%">{this.props.job.simpro_job.Site.SiteName}</th> */}
											</tr>
											<tr>
												<th width="50%">Job Completion Date </th>
												<th>
													<div className="date-picker-icon">
														<MdDateRange />
														<DatePicker
															hintText="Job Completion Date "
															container="inline"
															formatDate={(date) => moment(date).format('MMM-DD-YYYY')}
															onChange={this.setDate}
															value={this.props.job.job_completion_date ? completionDate : null}
														/>
														{createJobManualError.job_completion_date && createJobManualError.job_completion_date.length > 0 && <span style={{ color: 'red' }}>{createJobManualError.job_completion_date}</span>}

														{/*<span style={{ color: 'red' }}>{this.state.dateIsReqText}</span>*/}
													</div>
												</th>
											</tr>
											<tr>
												<th width="50%"> O&amp;M Author </th>
												<th>
													<div>
														<input type="text" name="jobAuthor" placeholder="Author Name" value={author} onChange={this.changeJobAuthorText} onBlur={this.setAuthor} style={{
															'borderTop': 0,
															'borderLeft': 0,
															'borderRight': 0,
															'borderBottom': '1px solid rgba(0, 0, 0, 0.1)'
														}} />
														{/* {createJobManualError.jobAuthor && createJobManualError.jobAuthor.length > 0 && <span style={{ color: 'red' }}>{createJobManualError.jobAuthor}</span>} */}
													</div>
												</th>
											</tr>
											<tr>
												<th width="50%">Template Set </th>
												<th>
													<SelectField
														onChange={this._selectTemplateSet}
														name="templateset"
														value={selected_template_set_id}
														floatingLabelFixed={true}
														hintText="Choose Template Set"
														className="selectInput"
														fullWidth={true}
														errorText={createJobManualError.templateset ? createJobManualError.templateset : ""}
													>
														{this._getTemplateSet()}
													</SelectField>
												</th>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div className="dashboard-table-data margb20px">
								<div className="audio-visual-list">
									<h3>Manuals</h3>
									<table className="dashboard-table manual-list tablepadd0">
										<thead>
											<tr>
												<th width="70%">Manual
													<div className="manual-info">
														<i className="zmdi zmdi-info"></i>
														<div className="information">
															<p>Click the template name to edit information from simPRO</p>
														</div>
													</div>
												</th>
												<th width="30%">Approved?</th>
												{/*<th width="30%">Template</th>*/}
											</tr>
										</thead>
										<tbody>
											{manuals}
										</tbody>
									</table>
								</div>
							</div>
							<Row className="rows audio-bottom-buttons" style={{ padding: '10px' }}>
								<Col md={6}>
									<FlatButton
										label="Remove Job"
										labelStyle={{ 'fontWeight': '600', 'textAlign': 'left', color: '#e94731' }}
										icon={<MdDelete color="#e94731" />}
										onClick={this.openModal}
										disabled={this.props.isCreatingDocument === true ? true : false}
									/>
								</Col>
								<Col md={6}>
									<div className="manualy-btn">
										<div className="forgotten-password reimport-btn" >
											<RaisedButton
												label="Re-import"
												labelColor="#fff"
												labelStyle={{ 'fontWeight': '500' }}
												fullWidth={false}
												onClick={this.openModalReimport}
											/>
										</div>
										<div className="forgotten-password">
											<RaisedButton
												label="Create Job Manual"
												type="submit"
												labelColor="#fff"
												labelStyle={{ 'fontWeight': '500' }}
												fullWidth={false}
												onClick={this.createManual}
												disabled={checkmanual ? false : true}
											/>
										</div>
									</div>
								</Col>
							</Row>
						</div>
					</div>
				</div>
			)} />
			<Dialog
				actions={action}
				className="model-support"
				modal={false}
				contentClassName="model-top-overlay no-overlay"
				open={this.state.modalIsOpen}
				onRequestClose={this.closeModal}
			>

				<div className="other-popup-content learn-more-popup">
					<form className="import-job-modal" >
						<h2 >Do you want to delete this job permanently?</h2>

					</form>
				</div>
			</Dialog>

			{this.props.jobs.tokenStatus === 1 && this.props.signup.disableaAuthorizeButton === false ?
				<Dialog
					actions={action1}
					className="model-support"
					modal={true}
					open={this.state.authorizeModal}
					onRequestClose={this.closeAuthorizePopup}
					contentClassName="model-top-overlay no-overlay"
				>
					<Row>
						<Col md={12}>
							<div style={{ textAlign: 'center' }} >
								<p>Your simPRO access has expired.</p>
							</div>
						</Col>
					</Row>
				</Dialog>
				: null
			}
			{this.props.signup.disableaAuthorizeButton === true ?
				<Dialog
					className="model-support"
					modal={false}
					open={this.state.authorizeLoader}
					contentClassName="model-top-overlay no-overlay"
				>
					<Row>
						<Col md={12}>
							<div style={{ textAlign: 'center' }} onClick={this.closeModal} >
								<div className="progressbar1">
									<LinearProgress mode="indeterminate" />
								</div>
								<p>Please! wait while processing...</p>
							</div>
						</Col>
					</Row>
				</Dialog> : null
			}

			{this.props.isCreatingDocument ?
				<Dialog
					className="model-support template_modal_dialog security_steps_wrap_modal"
					modal={false}
					open={this.state.modalIsOpenManual}
					onRequestClose={this.closeModalManual}
					contentClassName="model-top-overlay no-overlay"
				>
					<DialogContent>
						<div>
							<h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>Creating Manual...</h3>
							{/* <div className="sweet-loading">
                                   <BarLoader
                                       height={15}
                                       width={500}
                                       size={150}
                                       color={"#3699ff"}
                                       loading={true}
                                   />
                               </div>*/}
							<div className="security_steps_wrap">
								<ul>
									<li className={this.state.importStatus ? "active complete" : "active"}>
										<span className="lable_step">Preparing Files</span>
										<span className="step_check"></span>
									</li>
									<li className={this.state.mergeStatus ? "active complete" : "lable_step"}>
										<span className="lable_step">Merging Files</span>
										<span className="step_check"></span>
									</li>
									<li className={this.state.optimizeStatus ? "active complete" : "lable_step"}>
										<span className="lable_step">Compressing Files</span>
										<span className="step_check"></span>
									</li>
									<li className={this.state.pdfStoreStatus ? "active complete" : "lable_step"}>
										<span className="lable_step">Storing Files</span>
										<span className="step_check"></span>
									</li>
									<li className={this.state.pdfConvertStatus ? "active complete" : "lable_step"}>
										<span className="lable_step">Finalizing Files</span>
										<span className="step_check"></span>
									</li>
								</ul>
							</div>
						</div>
					</DialogContent>
				</Dialog>
				: null}

			{this.props.ismanualSendingToSimpro && this.props.jobs.tokenStatus !== 1 ?
				<Dialog
					className="model-support"
					modal={false}
					open={this.state.modalIsOpenManual}
					onRequestClose={this.closeModalManual}
					contentClassName="model-top-overlay no-overlay"
				>
					<Row>
						<Col md={12}>
							<div style={{ textAlign: 'center' }} >
								<div className="progressbar1">
									<LinearProgress mode="indeterminate" />
								</div>
								<p>Your Manual is being uploaded to simPRO...</p>
							</div>
						</Col>
					</Row>
				</Dialog>
				: null}

			{!this.props.isReimporting ?
				!this.props.reimportsuccess ?
					<Dialog
						actions={actionReimport}
						className="model-support"
						modal={false}
						contentClassName="model-top-overlay no-overlay"
						open={this.state.modalIsOpenReimport}
						onRequestClose={this.closeModalReimport}
					>

						<div style={{ textAlign: 'center' }} className="other-popup-content learn-more-popup">
							<form className="import-job-modal" >
								<h2 className="re-import-heading">Re-import</h2>
								<h2 >If you re-import your job any changes made will be overwritten as will any job manuals created. You may want to delete any existing manuals that have been uploaded into simPRO.</h2>

							</form>
						</div>
					</Dialog>
					:
					<Dialog
						className="model-support"
						modal={false}
						contentClassName="model-top-overlay no-overlay"
						open={this.state.modalIsOpenReimport}
						onRequestClose={this.closeModalReimport}
					>
						<div style={{ float: 'right', padding: '5px', margin: '-16px', cursor: 'pointer' }} onClick={this.closeModalPopup}> <img src="/images/cross.svg" alt="logo" /></div>

						<Row>
							<Col md={12}>
								<p className="success-msg" style={{ textAlign: 'center' }}>
									<span>
										<img src="/images/green.png" height="50" width="50" alt="imported img" />
									</span>
									<span className="success-text">
										<p>Your job is re-importing, you will receive an email when complete.</p>
										{(!_.isEmpty(this.props.failedAttachments) || !_.isEmpty(this.props.failedAttachments)) ?
											<p className="file-error-note">Note: If these files are needed please remove protection and re-import</p> : ""}
									</span>
								</p>
								{(!_.isEmpty(this.props.failedAttachments) || !_.isEmpty(this.props.failedAttachments)) ?
									<div className="errorlist-wrap">
										{!_.isEmpty(this.props.failedAttachments) && <h3 className="err-heading" >Failed Attachments :</h3>}
										<ul>
											{this.props.failedAttachments && _.map(this.props.failedAttachments, (filesattach, i) => {
												return <li className="error-msg">{filesattach}</li>
											})}
										</ul>
										{!_.isEmpty(this.props.failedStockAttachments) && <h3 className="err-heading" >Failed Stock Attachments :</h3>}
										<ul>
											{this.props.failedStockAttachments && _.map(this.props.failedStockAttachments, (files, i) => {
												return <li className="error-msg" >{files}</li>
											})}
										</ul>
									</div>
									: ""}

							</Col>
						</Row>
					</Dialog>
				:
				<Dialog
					className="model-support"
					modal={false}
					open={this.state.modalIsOpenReimport}
					onRequestClose={this.closeModalReimport}
					contentClassName="model-top-overlay no-overlay"
				>
					<Row>
						<Col md={12}>
							<div style={{ textAlign: 'center' }}>
								<div className="progressbar1">
									<LinearProgress mode="indeterminate" />
								</div>
								<p>Your job is being re-imported...</p>
							</div>
						</Col>
					</Row>
				</Dialog>
			}

			{
				this.props.simproAuthenticationFailed ?
					<Dialog
						actions={[
							<FlatButton
								label="Cancel"
								primary={true}
								onClick={this.cancelSimproUpdate}
							/>,
							<RaisedButton
								type='Submit'
								label={this.props.simproUpdating ? <CircularProgress size={32} color="#fff" /> : "Update"}
								onClick={this.authorizeApi}
								labelColor="#fff" />,
						]}
						className="model-support"
						modal={false}
						open={this.props.simproAuthenticationFailed}
						// onRequestClose={this.closeModalReimport}
						contentClassName="model-top-overlay no-overlay"
					>
						<Row>
							<Col md={12}>
								<div style={{ textAlign: 'center' }}>
									<Row>
										<form name="simpro-details-update" onSubmit={(e) => { e.preventDefault() }} >
											<Col md={12}>
												<Row>
													<Col md={12}>
														<h2 className='simpro-login-heading'>SIMPRO LOGIN UPDATE</h2>
														<p className='simpro-login-message'>Seems like your username or password has been updated on simPro, please provide us with the new details.</p>
														<p className="simpro-login-message file-error-note">Note: Your current job will need to be removed but you can then import it again.</p>
														{this.props.simproErrorMessage ? <div><div className="error-icon">
															<i class="zmdi zmdi-mood-bad"></i>
														</div><p>Failed to update simpro Details</p></div> : ''}
													</Col>
												</Row>
												<Row>

												</Row>
											</Col>
											<Col md={12}>
												<Row>
													<Col md={12}>
														<TextField
															hintText="Enter your simPRO username"
															fullWidth={true}
															floatingLabelFixed={true}
															name='simpro_username'
															errorText={this.state.simpro_name_req}
															onChange={this.simPROUser}
															readOnly
                                                            onFocus={this.handleFocus}
														/>
													</Col>
													<Col md={12}>
														<TextField
															hintText="Enter your simPRO Password"
															fullWidth={true}
															floatingLabelFixed={true}
															name='simpro_password'
															type="password"
															errorText={this.state.simpro_pass_req}
															onChange={this.simPROpassword}
															readOnly
                                                            onFocus={this.handleFocus}
														/>
													</Col>
													{/* <Col md={12}>
																								
												<RaisedButton type='Submit' label={this.props.simproUpdating?<CircularProgress size={32} color="#fff"/>:"Update"} onClick = {this.authorizeApi} labelColor="#fff" fullWidth={true} />
												
												<RaisedButton type='Submit' label={"Cancel"} onClick = {this.cancelSimproUpdate} labelColor="#fff" className="mt-5" fullWidth={true} />
												</Col> */}
												</Row>
											</Col>
										</form>
									</Row>
								</div>
							</Col>
						</Row>
					</Dialog> : ''
			}

			<Dialog
				className="model-support createManualErrorPopup"
				modal={false}
				contentClassName="model-top-overlay no-overlay"
				open={this.props.isOpenModalForError}
				onRequestClose={this.closeModalPopupForError}
			>
				<div className="close-model-error" style={{ float: 'right', padding: '5px', margin: '-16px', cursor: 'pointer' }} onClick={this.closeModalPopupForError}> <img src="/images/cross-error.svg" alt="logo" /></div>

				<div className="create_manual_error">
					<div className="error-icon">
						<i class="zmdi zmdi-mood-bad"></i>
					</div>
					<div className="job-error-popup">
						<h1>Oops... </h1>
						{this.props.createManualErrorType === 'template error' ?
							<div>
								<p>Something went wrong creating your manual.</p>
								<p>The team have been alerted and are on the case. Please try again in a few minutes.</p>
							</div>
							: null}

						{this.props.createManualErrorType === 'mergefile error' && this.props.createManualErrorFileName ?
							<div>
								<p>The file {this.props.createManualErrorFileName} is password protected so cannot be used in the manual. Please either de-select the file or remove the security on the file in simPRO and re-import your job</p>
								<p><a className={this.props.ismoreFilesClicked ? "more-encrypted" : ""} onClick={(e) => this.findAllEncryptedFiles(2)} target="_blank"> Click here </a>to check if any other files are password protected</p>
							</div>
							: null}

						{this.props.createManualErrorType === 'download error' ?
							<div>
								<p>One of your files contains characters that can't be used when merging documents.  To fix the file please update the name in simPRO removing any symbol like characters and re-import the job.</p>
								<p><a className={this.props.ismoreFilesClicked ? "more-encrypted" : ""} onClick={(e) => this.findAllEncryptedFiles(1)} target="_blank"> Click here </a>to see which files are affected.</p>
							</div>
							: null}

						{this.props.moreEncryptedFiles.length === 0 && this.props.ismoreFilesClicked === true && <p><CircularProgress size={32} /></p>}
						{this.props.moreEncryptedFiles.length !== 0 && this.props.ismoreFilesClicked === false ?
							<p>
								{this.props.createManualErrorType === 'mergefile error' ? 'These are your encrypted files:' : 'These files are affected:'}
								{this.renderErrorFiles()}
							</p>
							: null
						}


						{this.props.createManualErrorType === 'mergefile error' || this.props.createManualErrorType === 'download error' ?
							<div>
								<p><a className={this.props.ismoreFilesClicked ? "more-encrypted" : ""} href="https://www.dokkit.co.uk/encrypted-pdfs/" target="_blank"> learn more</a></p>
							</div>
							: null
						}
						{this.props.createManualErrorType !== 'template error' && this.props.createManualErrorType !== 'mergefile error' && this.props.createManualErrorType !== 'download error' ?
							<div>
								<p>Something went wrong creating your manual.</p>
							</div>
							: null
						}
					</div>
				</div>
			</Dialog>
		</div>
		)
	}
}

const mapStateToProps = (state, { match }) => {
	const jobId = match.params.jobId;
	return {
		error: state.jobs.error,
		job: getJobById(state, jobId),
		isImporting: state.jobs.isImporting,
		isReimporting: state.jobs.isReimporting,
		isCreatingDocument: state.jobs.isCreatingDocument,
		isOpenModalForError: state.jobs.isOpenModalForError,
		createManualErrorType: state.jobs.createManualErrorType,
		createManualErrorFileName: state.jobs.createManualErrorFileName,
		moreEncryptedFiles: state.jobs.moreEncryptedFiles,
		ismoreFilesClicked: state.jobs.ismoreFilesClicked,
		mergeFilesListing: state.jobs.mergeFiles,
		cloudConvertRes: state.jobs.cloudConvertRes,
		importedJobId: state.jobs.importedJobId,
		isUploadingFile: state.jobs.isUploadingFile,
		currentuser: state.login,
		tokenStatus1: state.login.tokenStatus,
		jobs: state.jobs,
		reimportsuccess: state.jobs.reimportsuccess,
		failedStockAttachments: state.jobs.failedStockAttachments,
		failedAttachments: state.jobs.failedAttachments,
		ismanualSendingToSimpro: state.jobs.ismanualSendingToSimpro,
		signup: state.signup,
		templates: state.templates,
		companyTemplateSet: state.company.companyTemplateSet || [],
		simproAuthenticationFailed: state.jobs.simproAuthenticationFailed,
		simproUpdating: state.jobs.simproUpdating,
		simproUpdated: state.jobs.simproUpdated,
		simproErrorMessage: state.jobs.errorMessagesimpro,
		errorMessageForNotFound: state.jobs.errorMessageForNotFound,
		manualStatus: [...new Set(state.jobs.manual_task_status)]
	}
};
JobDetails = withRouter(connect(
	mapStateToProps,
	actions
)(JobDetails));

export default JobDetails;


// WEBPACK FOOTER //
// ./src/Components/Pages/JobDetails.js